<template>
  <div class="sa-mob-cont">
    <div class="sa-mob-header">
      <h5 class="sa-card-tit">View record</h5>
      <button class="sa-btn-back" @click="$parent.ViewRecordFlag=false">
        <i class="icon-arrow-left"></i>
      </button>
    </div>
    <div class="sa-card sa-card-non">
      <div class="sa-rname">
        <span><span class="img-rico m-r10 el-avatar">{{records.patientDetails.pname_short}}</span>{{records.patientDetails.pname}}</span>
        <div class="sa-black-text">
          <span class="sa-mr20"><i class="sa-sprite sa-lung-img-small sa-mr15"></i>{{recordObj.cat_nm}}</span>
          <span class="sa-rname-cal"><i class="icon-calendar3 sa-f-size18 sa-blue-text sa-mr15"></i>{{recordObj.created}}</span>
        </div>
      </div>
      <ul class="sa-mpersonal sa-tab-cont sa-file-records">
      <li class="sa-col-xs12 sa-col-sm6 sa-col-md4 sa-col-lg3">File Name<span>{{recordObj.file_nm}}</span></li>
      <li v-if="recordObj.type_nm" class="sa-col-xs12 sa-col-sm6 sa-col-md4 sa-col-lg3">Type<span>{{recordObj.type_nm}}</span></li>
      <li class="sa-col-xs12 sa-col-sm6 sa-col-md4 sa-col-lg6">Attachment
         <!-- <a :href="i.URL" class="sa-d-f-a-center  sa-mt10 sa-d-f-a-center sa-mt10 sa-f-up-info" target="_blank" :v-if=" recordObj && recordObj.files > 0" v-for="i in recordObj && recordObj.files" :key="i.FILENAME">
          <span  v-if="isImage(getFileExtension(i.FILENAME))">
           <img :src="i.URL" class="sa-img-cover sa-mr5" />
           </span>
            <i :class="`icon-${getFileExtension(i.FILENAME).toLowerCase()}`" class=" sa-f-size18 sa-mr5" v-else></i>{{i.FILENAME}}
         </a> -->
         <file-upload-multiple
                    :pflag="pflag"
                    :fileData="recordObj.files.map(_=> ({file_nme: _.FILENAME,url: _.URL}))" :show-upload="false" :showName="false"
                  />
      </li>
      </ul>
    </div>
  </div>
</template>
<script>
import FileUploadMultipleVue from "../common/FileUploadMultiple.vue";
export default {
  props: ["records", "recordObj"],
   components: {
    "file-upload-multiple": FileUploadMultipleVue
  },
    data() {
    return {
      pflag:false
    }
    },
     methods: {
        getFileExtension(fileName) {
                let fileType = fileName.split(".").pop();
                return fileType;
            },
            isImage(ext) {
                if(!ext){
                    return false;
                }
                const imgFtypes = ["jpg", "jpeg", "png", "gif", "bmp", "tif", "tiff", "eps","svg","raw","jfif"]
                return imgFtypes.indexOf(ext) !== -1;
            },
}
}
</script>
